import { Grid } from '@statsbomb/kitbag-components';
import React from 'react';
import DownloadsInProgress from '../../components/DownloadsInProgress';
import EditsDisplay from '../../components/EditsDisplay';
import Ingest from '../../components/Ingest';
import UploadStatus from '../../components/UploadStatus';

export function Upload() {
  return (
    <Grid>
      <Grid item xs={12}>
        <Ingest allowReEncoding />
      </Grid>
      <Grid item xs={12}>
        <UploadStatus />
      </Grid>
      <Grid item xs={12}>
        <DownloadsInProgress />
      </Grid>
      <Grid item xs={12}>
        <EditsDisplay />
      </Grid>
    </Grid>
  );
}

export default { Upload };
